import createReactComponent from '../createReactComponent';
export default createReactComponent('brand-flutter', 'IconBrandFlutter', [
  ['path', { d: 'M7 14l-3 -3l8 -8h6z', key: 'svg-0' }],
  ['path', { d: 'M14 21l-5 -5l5 -5h5l-5 5l5 5z', key: 'svg-1' }],
]);
